import axios from 'axios'
import EnvConfig from '../../config/env'

import {
  parserToken
} from './actions'


export default function axiosApi(url) {
  let self = this || {};
  const baseUrl = url || EnvConfig.REACT_APP_API_URL
    
  const init = function(){
    self = axios.create({
      baseURL: baseUrl,
      headers: {
        'token': parserToken(localStorage.getItem('token')).Token,
        "Content-Encoding":"gzip",
        'Access-Control-Allow-Origin':'*',
      }
    });
  }

  init();

  return self;
}

export function axiosReportApi() {
  return axiosApi(EnvConfig.REACT_APP_API_REPORTING_URL)
}


// WEBPACK FOOTER //
// ./src/views/client/axiosClient.js